<template>
  <form-poll v-if="resourceObject.type == 'poll'" :poll="resourceObject.id" />
  <a href="#" @click="handleClick" class="resource-holder" v-else>
    <span>
      <file-icon
        v-if="
          !iconExclude.includes(resourceObject.type) && resourceInfo.name
        "
        :type="resourceInfo.name | extension"
      ></file-icon>
      <file-icon
        v-else-if="!iconExclude.includes(resourceObject.type)"
        type="pdf"
      ></file-icon>
      <file-icon v-else-if="isLink" type="link"></file-icon>
      <file-icon v-else type="link"></file-icon>
    </span>
    <span>{{ title || resourceTitle }}</span>
    <div
      v-if="!['page', 'eform'].includes(resourceObject.type)"
      class="resource-holder__icon"
    >
      <icon width="18" height="18" icon="download"></icon>
    </div>
    <div v-else class="resource-holder__icon">
      <icon width="18" height="18" icon="arrow"></icon>
    </div>
  </a>
</template>

<script>
import api from '@/api'

export default {
  name: 'media-document',

  props: {
    resourceLink: String,
    title: {
      type: String,
      default: ''
    },
    isLink: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      resourceTitle: '',
      resourceId: '',
      resourceObject: {},
      resourceInfo: {},
      iconExclude: ['page', 'eform','survey','poll']
    }
  },

  watch: {
    resourceLink: {
      immediate: true,
      handler: function(val) {
        this.resourceObject = JSON.parse(val)
        this.resourceTitle = this.title || this.resourceObject.name
        this.getFileInfo(val)
      }
    }
  },

  created() {
    const { resourceLink, title, $store } = this
    if (resourceLink) {
      try {
        this.resourceObject = JSON.parse(resourceLink)
        this.resourceTitle = title || this.resourceObject.name
        this.getFileInfo(resourceLink)
      } catch (err) {}
    }
  },

  methods: {
    getFileInfo(data) {
      try {
        var obj = JSON.parse(data)
      } catch (err) {
        var obj = null
      }
      if (obj) {
        this.resourceId = obj.id.split('/')[1]
        // If we are a form or policy we need to get info about the file
        if (
          this.resourceObject.type !== 'page' &&
          this.resourceObject.type !== 'eform'
        ) {
          this.$store.dispatch('files/read', this.resourceId).then(resp => {
            this.resourceInfo = resp
          })
        }
      }
    },
    /**
     * Depending on the type of object we are linking
     * Policy / Form needs to read the file API
     * Content -> needs to just link to content
     */
    handleClick(e) {
      e.preventDefault()

      //if we are in the admin, don't do anything
      if (this.$route.meta.isAdmin) {
        return false
      }
      let ready = false
      const { $store, resourceObject, $router, resourceInfo } = this

      if (resourceObject.type === 'page') {
        if (resourceObject.pageId) {
          let response

          api()
            .get(`/content/page/${resourceObject.pageId}/flat`)
            .then(response => {
              const { page_url } = response.data.data.page[0]
              return window.open(`/content${page_url}`)
            })
            .catch(err => {
              return window.open(`/content${resourceObject.id}`)
            })
        } else {
          // new window
          return window.open(`/content/${resourceObject.id}`)
        }
        // or redirect
        // return $router.push(`/content/${resourceObject.id}`);
      } else if (['eform','survey'].includes(resourceObject.type)) {
        // new window
        return window.open(`${resourceObject.id.replace('/form/','/forms/')}`)
        // or redirect
        // return $router.push(`/content/${resourceObject.id}`);
      } else {
        const docType = resourceObject.type
        if (
          !$store.state.documents.docType ||
          docType !== $store.state.documents.docType.plural
        ) {
          $store.commit('documents/setDocType', docType)
          ready = true
        } else {
          ready = true
        }

        if (ready) {
          $router.push({
            name: 'ContentPageWithParentAllSlidout',
            params: { id: resourceObject.documentId, docType }
          })
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.resource-holder {
  border-bottom: 1px solid $colour-nhs-pale-grey;
  display: flex;
  align-items: center;
  padding: 10px;
  box-sizing: border-box;
  text-decoration: none;
  transition: box-shadow 0.2s ease;
  position: relative;

  line-height: 1;

  .c-file-icon {
    margin-right: 10px;
  }

  &:hover {
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.11);
    cursor: pointer;

    .resource-holder__icon {
      svg {
        fill: $colour-cactus-core-green;
      }
    }
  }

  &__icon {
    border-left: 1px solid $colour-nhs-pale-grey;
    position: absolute;
    padding: 25px 25px 20px;
    box-sizing: border-box;
    top: 0;
    right: 0;
    height: 100%;
    align-content: center;

    svg {
      fill: $colour-nhs-mid-grey;
      transition: fill 0.2s ease;
      transform: scale(1.25);
    }
  }
}
</style>
